import { useEditorialMediaUrl } from "@/lib/useEditorialMediaUrl";
import { cardDisplaySection, editorialCardTitle, thumbnailFromEditorialBlocks, thumbnailMediaIdFromBlocks } from "@/lib/editorialVisualCatalogV2.mjs";
import { Image as ImageIcon, PenLine, Trash2 } from "lucide-react";

export default function EditorialVisualCard({ material, blocks = [], workspaceKey, workspaceTitle, placement, onEdit, onDelete, canDelete = false, deleteHelp = "" }) {
  const direct = thumbnailFromEditorialBlocks(blocks, material);
  const mediaId = thumbnailMediaIdFromBlocks(blocks, material);
  const src = useEditorialMediaUrl(direct, mediaId);
  const published = material.status === "published" || !!material.published_snapshot_id;
  return (
    <article className="min-w-0 overflow-hidden rounded-2xl border border-espresso/10 bg-white/90 shadow-sm flex flex-col" data-testid={"editorial-visual-card-" + material.id}>
      <button type="button" onClick={onEdit} className="w-full text-left group" aria-label={"Открыть материал: " + editorialCardTitle(material)}>
        <div className="aspect-[3/4] w-full overflow-hidden bg-[#EFE5D5] flex items-center justify-center">
          {src
            ? <img src={src} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.02]" />
            : <div className="flex flex-col items-center gap-2 text-espresso/45"><ImageIcon className="w-8 h-8" /><span className="text-xs">Фото пока нет</span></div>}
        </div>
        <div className="px-3 pt-3 text-left">
          <div className="font-serif text-[17px] leading-tight line-clamp-3 min-h-[3.1em] text-espresso">{editorialCardTitle(material)}</div>
          <div className="text-[10px] uppercase tracking-[0.11em] text-espresso/55 mt-2 line-clamp-1">{workspaceTitle || "Мои публикации"}</div>
          <div className="text-xs text-[#765B40] mt-1 line-clamp-2">{cardDisplaySection(material, workspaceKey, placement)}</div>
          <div className="mt-2 text-[11px] text-espresso/60">{published ? (material.status === "draft" ? "Опубликовано · есть изменения" : "Опубликовано") : "Черновик"}</div>
        </div>
      </button>
      <div className="mt-auto p-3 flex flex-wrap items-center gap-2">
        <button type="button" onClick={onEdit} className="rounded-lg border hairline bg-white px-2.5 py-2 text-xs text-espresso hover:bg-sand/30" data-testid={"editorial-space-edit-" + material.id}>
          <PenLine className="inline h-3.5 w-3.5 mr-1" /> Редактировать
        </button>
        <button type="button" onClick={canDelete ? onDelete : undefined} disabled={!canDelete}
          title={!canDelete ? deleteHelp : "Удалить черновик"}
          className="rounded-lg border border-red-200 px-2.5 py-2 text-xs text-red-800 hover:bg-red-50 disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid={"editorial-space-delete-" + material.id}>
          <Trash2 className="inline h-3.5 w-3.5 mr-1" /> Удалить
        </button>
      </div>
    </article>
  );
}
